import { FC, PropsWithChildren } from 'react';
import { GradientWithImage } from './GradientWithImage';
import { StyleProp, ViewStyle } from 'react-native';
import { contentTypeForActivityItem } from '../../types/types';
import { observer } from 'mobx-react';
import { useContentInfo } from '../../hooks/content/useContentInfo';

interface ActivityImageProps extends PropsWithChildren {
  id: string;
  contentType: contentTypeForActivityItem;
  width: number;
  height: number;
  style?: StyleProp<ViewStyle> | undefined;
}

const _ActivityImage: FC<ActivityImageProps> = ({ id, contentType, children, width, height, style }) => {
  const { image, color } = useContentInfo(id, contentType);

  return (
    <GradientWithImage image={image} designSystemColor={color} width={width} height={height} style={style}>
      {children}
    </GradientWithImage>
  );
};

export const ActivityImage = observer(_ActivityImage);
